var _path, _path2, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 53,
    viewBox: "0 0 52 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0588 5.93926L12.0887 6.10371L13.1491 6.40298L34.2893 14.0884L35.2145 14.4659L36.1026 14.9451L36.947 15.5155L37.7407 16.1668L38.4769 16.8893L39.1484 17.6732L39.7478 18.5092L40.2676 19.3877L40.6999 20.2997L41.0365 21.236L41.2689 22.1873L41.3881 23.1443L41.7646 44.0184L41.7646 44.019L41.6378 45.0331L41.3881 45.9711L41.0219 46.8248L40.5457 47.5856L39.9662 48.2445L39.2904 48.7919L38.5253 49.2183L37.6787 49.5136L36.7582 49.668L35.7727 49.6713L34.7307 49.5135L11.3733 44.5328L10.232 44.2691L9.03153 43.7546L7.88394 43.0094L6.85672 42.2345L5.91861 41.3499L5.08189 40.3704L4.35849 39.3114L3.75983 38.1887L3.29684 37.0179L2.97983 35.815L2.81836 34.5955L2.8215 33.3754L4.67646 10.8993L4.82534 9.92088L5.11494 9.03809L5.53286 8.25584L6.06683 7.57863L6.70486 7.01062L7.43521 6.5557L8.24652 6.21756L9.12784 5.99976L10.0686 5.90582L11.0588 5.93926ZM41.7646 44.0184L41.3881 23.1443L41.7622 42.9367L41.7646 44.0184Z",
    fill: "url(#paint0_linear_244_3922)",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33529 4.015L9.18641 4.99342L7.42621 29.2376L7.42307 30.4577L7.5845 31.677L7.90154 32.88L8.36454 34.0508L8.9632 35.1736L9.6866 36.2325L10.5233 37.212L11.4614 38.0967L12.4886 38.8716L13.5923 39.5221L14.7596 40.0343L15.9774 40.3949L40.9571 46.0527L41.999 46.2105L42.9846 46.2073L43.905 46.0529L44.7516 45.7576L43.9086 46.2572L43.1465 46.6821L42.3411 47.1598L43.1461 46.6823L43.1465 46.6821L43.9086 46.2572L44.7516 45.7576L45.5168 45.3312L43.9094 46.2567L43.909 46.257L43.9086 46.2572L43.1465 46.6821L42.3411 47.1598L40.8116 48.0406L39.3192 48.9L38.565 49.3208L37.7341 49.6164L36.8347 49.7772L35.8751 49.7933L34.8642 49.6552L10.7606 44.5615L9.5914 44.2328L8.47366 43.7582L7.41955 43.1501L6.44113 42.4218L5.55026 41.5869L4.75847 40.6596L4.07692 39.6543L3.51634 38.5858L3.08699 37.469L2.79856 36.3187L2.66016 35.1498L2.68026 33.9773L4.72433 10.5438L4.88256 9.59226L5.17574 8.7301L6.66398 6.61054L7.19302 5.9397L8.29327 4.55228L9.42071 3.13058L10.5757 1.67413L10.0428 2.34996L9.62489 3.13221L9.33529 4.015Z",
    fill: "url(#paint1_linear_244_3922)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_244_3922)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5695 0.0334379L16.5994 0.19789L17.6598 0.497153L39.4958 7.98789L40.421 8.36535L41.3091 8.84455L42.1535 9.41494L42.9472 10.0663L43.6834 10.7888L44.3549 11.5727L44.9543 12.4086L45.4741 13.2872L45.9064 14.1992L46.243 15.1355L46.4754 16.0867L46.5946 17.0438L47.9918 40.5577L47.9918 40.5583L47.865 41.5724L47.6153 42.5104L47.2491 43.3641L46.7729 44.1249L46.1934 44.7838L45.5176 45.3312L44.7525 45.7576L43.9058 46.0529L42.9854 46.2073L41.9998 46.2106L40.9579 46.0528L15.9787 40.3951L14.8375 40.1313L13.637 39.6168L12.4894 38.8716L11.4622 38.0968L10.5241 37.2121L9.68736 36.2326L8.96396 35.1737L8.3653 34.0509L7.90231 32.8801L7.5853 31.6772L7.42383 30.4577L7.42697 29.2377L9.18717 4.99348L9.33605 4.01506L9.62565 3.13227L10.0436 2.35002L10.5775 1.67281L11.2156 1.1048L11.9459 0.649875L12.7572 0.311741L13.6385 0.0939421L14.5793 0L15.5695 0.0334379ZM47.9918 40.5577L46.5946 17.0438L47.9894 39.476L47.9918 40.5577Z",
    fill: "url(#paint2_linear_244_3922)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.49 40.542L47.3731 41.4766L47.1414 42.3466L46.8048 43.1315L46.3706 43.8252L45.8459 44.4218L45.2365 44.9154L44.5469 45.2997L43.7812 45.5669L42.9429 45.7075L42.0367 45.7105L41.0507 45.5611L16.0913 39.9079L16.0892 39.9074L14.9935 39.6542L13.8734 39.1741L12.7765 38.4618L11.7853 37.7141L10.8867 36.8668L10.085 35.9283L9.39227 34.9142L8.81984 33.8407L8.37822 32.7239L8.07683 31.5803L7.92391 30.4254L7.92692 29.2564L9.68444 5.04927L9.82411 4.13139L10.0872 3.32948L10.4637 2.62476L10.9429 2.01697L11.5162 1.50663L12.1758 1.09576L12.9143 0.787968L13.7238 0.587916L14.5958 0.500841L15.5215 0.5321L16.4917 0.687029L17.5107 0.974594L39.3201 8.45622L40.2072 8.81815L41.0498 9.27278L41.8543 9.81623L42.6128 10.4387L43.3177 11.1305L43.9611 11.8816L44.5352 12.6821L45.0321 13.5221L45.4442 14.3913L45.7636 15.2797L45.9828 16.1773L46.0964 17.0896L47.49 40.542Z",
    stroke: "url(#paint3_linear_244_3922)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_244_3922)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8827 19.2563L18.8641 18.2056L17.7009 19.4513L17.8827 19.2563ZM41.5591 20.1171L28.3521 29.902L28.3509 29.9029L28.1184 30.0467L27.8672 30.1495L27.601 30.2121L27.3236 30.2351L27.0385 30.2193L26.7497 30.1655L26.4609 30.0744L26.176 29.9469L25.8989 29.784L25.4873 30.3145L25.0757 30.845L25.3575 30.9698L25.6433 31.0586L25.9294 31.1106L26.2119 31.125L26.4871 31.101L26.7513 31.0378L27.0008 30.9349L27.2321 30.7915L40.3973 21.031L40.3979 21.0305L41.5591 20.1171ZM18.6814 18.4015L17.7009 19.4513L17.5555 19.672L17.4469 19.9149L17.3755 20.1762L17.3418 20.4522L17.3461 20.7391L17.3887 21.0332L17.4699 21.3305L17.59 21.6272L17.7492 21.9193L17.9476 22.2029L24.0663 30.0039L24.2932 30.2634L24.5397 30.4908L24.8018 30.685L25.0757 30.845L25.4873 30.3145L25.8989 29.784L25.6335 29.5866L25.3837 29.3556L25.1535 29.0923L18.9426 21.1813L18.7411 20.8938L18.5791 20.598L18.4566 20.2977L18.3733 19.997L18.329 19.6998L18.3234 19.4101L18.3562 19.1316L18.4271 18.8681L18.5356 18.6235L18.6814 18.4015ZM18.6814 18.4015L18.8641 18.2056L17.7009 19.4513L18.6814 18.4015Z",
    fill: "url(#paint4_linear_244_3922)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4521 17.3825L41.6276 17.6338L41.7734 17.8912L41.8894 18.1517L41.9754 18.4123L42.0313 18.6697L42.057 18.921L42.052 19.1628L42.0163 19.392L41.9496 19.6054L41.8514 19.7996L41.7216 19.9713L41.5599 20.1171L28.3526 29.9023L28.3517 29.9029L28.1192 30.0467L27.8681 30.1495L27.6019 30.2121L27.3244 30.2351L27.0393 30.2193L26.7505 30.1655L26.4617 30.0744L26.1768 29.9469L25.8997 29.784L25.6343 29.5865L26.8556 24.6871L38.7711 16.491L38.9625 16.3845L39.1703 16.3149L39.3912 16.2808L39.622 16.2811L39.8595 16.3146L40.1006 16.38L40.3423 16.4762L40.5815 16.6022L40.8151 16.7568L41.0401 16.939L41.2534 17.1479L41.4521 17.3825ZM18.3571 19.1314L18.4279 18.8681L18.5364 18.6236L19.3311 17.9106L20.4515 17.796L20.7455 17.8611L21.0375 17.9613L21.3238 18.0954L21.6008 18.2624L21.8647 18.4611L22.112 18.6905L22.339 18.9499L26.8556 24.6871L25.6343 29.5865L25.3845 29.3556L25.1543 29.0923L18.9434 21.1813L18.7419 20.8938L18.5799 20.598L18.4574 20.2977L18.3741 19.997L18.3298 19.6998L18.3242 19.4101L18.3571 19.1314ZM20.4515 17.796L20.1593 17.7671L19.8727 17.7757L19.5952 17.8231L19.3311 17.9106L20.4515 17.796ZM19.3311 17.9106L19.084 18.0394L18.8649 18.2055L18.6822 18.4014L18.5364 18.6236L19.3311 17.9106Z",
    fill: "url(#paint5_linear_244_3922)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_244_3922",
    x: -5.57617,
    y: -13,
    width: 66.5684,
    height: 72.2106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_244_3922"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_244_3922",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_244_3922",
    x: 0.636479,
    y: 11.6405,
    width: 50.7009,
    height: 40.8302,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3.71229,
    dy: 8.35266
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.49651
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.103333 0 0 0 0 0.4104 0 0 0 0 0.43 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_244_3922"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_244_3922",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_244_3922",
    x1: 3.94798,
    y1: 52.4191,
    x2: 39.5607,
    y2: 9.13991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.320833,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58125,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89375,
    stopColor: "white",
    stopOpacity: 0.79
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_244_3922",
    x1: -7.86491,
    y1: 8.19543,
    x2: 41.9389,
    y2: 57.9333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10CFC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35896,
    stopColor: "#10CFC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683604,
    stopColor: "#10CFC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#10CFC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10CFC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_244_3922",
    x1: 8.71306,
    y1: 47.9499,
    x2: 44.3258,
    y2: 4.67064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.320833,
    stopColor: "#10CFC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685417,
    stopColor: "#10CFC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89375,
    stopColor: "#10CFC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_244_3922",
    x1: 7.35079,
    y1: 41.7577,
    x2: 46.7598,
    y2: 8.69643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.180663,
    stopColor: "white",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533255,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_244_3922",
    x1: 16.2123,
    y1: 8.69695,
    x2: 16.4962,
    y2: 34.0698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.301696,
    stopColor: "#10CFC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993284,
    stopColor: "#E5007E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_244_3922",
    x1: 28.2804,
    y1: 34.5172,
    x2: 41.0624,
    y2: 11.7628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644664,
    stopColor: "white",
    stopOpacity: 0.57
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxRed);
export default __webpack_public_path__ + "static/media/Checkbox_Red.1cd7b29681b365caecd3e29c12b61c66.svg";
export { ForwardRef as ReactComponent };